$(document).ready(function(){

  if($('html').attr('lang') === 'ar'){

    const translations = {
      "Walnut veneer": "قشرة الجوز",
      "Oak veneer": "قشرة البلوط",
      "Charcoal veneer": "قشرة فحمية",
      "Size": "الحجم",
      "Table Top color": "لون سطح الطاولة"
    };

    $('.tt-title-options').each(function(){
      let text = $(this).contents().first().text().trim();
      if(translations[text]){
        $(this).contents().first()[0].textContent = translations[text] + ': ';
      }
    });

    $('.swatch-label').each(function(){
      let text = $(this).text().trim();
      if(translations[text]){
        $(this).text(translations[text]);
      }
    });

    $('.tt-options-swatch li a').each(function(){
      let text = $(this).text().trim();
      if(translations[text]){
        $(this).text(translations[text]);
      }
    });

  }

});



jQuery(document).ready(function ($) {

  // Normalize: trim, collapse whitespace, strip Arabic diacritics/tatweel, lowercase
  function normalizeText(str) {
    if (!str) return '';
    return str
      .replace(/[\u064B-\u0652\u0670\u0640]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function goToVariantSlide(variantText) {

    var $slider = $('.tt-mobile-product-slider');

    if (!$slider.hasClass('slick-initialized')) return;

    var variantMap = {
      "قشرة خشب الجوز": "Walnut veneer",
      "قشرة من الفحم": "Charcoal veneer",
      "قشرة البلوط": "Oak veneer",
      "خشب الجوز": "solid walnut",
      "خشب صلب اسود": "Solid Charcoal",
      "خشب البلوط": "solid oak"
    };

    var normalizedInput = normalizeText(variantText);

    for (var key in variantMap) {
      if (normalizeText(key) === normalizedInput) {
        variantText = variantMap[key];
        normalizedInput = normalizeText(variantText);
        break;
      }
    }

    var targetIndex = -1;

    // Pass 1: exact normalized match
    $slider.find('.slick-slide:not(.slick-cloned)').each(function () {
      var imgAlt = normalizeText($(this).find('img').attr('alt'));
      if (imgAlt && imgAlt === normalizedInput) {
        targetIndex = $(this).data('slick-index');
        return false;
      }
    });

    // Pass 2: fallback partial match (alt text describes more than just the variant name)
    if (targetIndex === -1) {
      $slider.find('.slick-slide:not(.slick-cloned)').each(function () {
        var imgAlt = normalizeText($(this).find('img').attr('alt'));
        if (imgAlt && (imgAlt.indexOf(normalizedInput) !== -1 || normalizedInput.indexOf(imgAlt) !== -1)) {
          targetIndex = $(this).data('slick-index');
          return false;
        }
      });
    }

    if (targetIndex != -1) {
      $slider.slick('slickGoTo', targetIndex, true);
    } else {
      console.warn('[mobile-slider] No matching slide for variant:', variantText);
    }
  }



});









document.addEventListener("DOMContentLoaded", function () {

  /* ✅ Arabic detect */
  var isArabic =
    (window.Shopify && Shopify.locale === 'ar') ||
    document.documentElement.lang.startsWith('ar');

  if (!isArabic) return;

  var links = document.querySelectorAll('a[href]');

  links.forEach(function (link) {

    /* 🚫 Skip language button */
    if (link.classList.contains('lang-btn')) return;

    /* 🚫 Skip logo link */
    if (link.classList.contains('tt-logo')) return;

    var href = link.getAttribute('href');

    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) return;

    /* 🔒 Prevent double /ar */
    if (href.includes('/ar/ar')) {
      link.setAttribute('href', href.replace('/ar/ar', '/ar'));
      return;
    }

    /* 🌍 Absolute URLs */
    if (href.includes('cervany.com') && !href.includes('/ar/')) {
      link.setAttribute(
        'href',
        href.replace('https://cervany.com', 'https://cervany.com/ar')
      );
      return;
    }

    /* 📂 Relative URLs */
    if (href.startsWith('/') && !href.startsWith('/ar')) {
      link.setAttribute('href', '/ar' + href);
    }
  });

});

(function () {
  const COLOR_SWATCH_MAP = {
    'solid walnut': { color: '#633E2F' },
    'solid oak': { color: '#A87D51' },
    'solid charcoal': { color: '#000000' },
    black: { color: '#000000' },
    white: { color: '#FFFFFF' },
    'stone grey': { color: '#CBC6BB' },
    gray: { color: '#808080' },
    gold: { color: '#D49A06' },
    beige: { color: '#EAD8AB' },
    brown: { color: '#9A5630' },
    bronze: { color: '#CD7F32' },

 // ENGLISH + ARABIC
'oak veneer': {
  color: '#B58648',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Oak_Veneer.png?v=1770300031',
},
'قشرة البلوط': { // Oak Veneer Arabic
  color: '#B58648',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Oak_Veneer.png?v=1770300031',
},

'walnut veneer': {
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Walnut_Veneer.jpg?v=1770300032',
},
'قشرة خشب الجوز': { // Walnut Veneer Arabic
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Walnut_Veneer.jpg?v=1770300032',
},

'solid walnut': {
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Solid_Walnut.png?v=1770300034',
},
'خشب الجوز': { // Solid Walnut Arabic
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Solid_Walnut.png?v=1770300034',
},

'charcoal veneer': {
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Charcoal_Veneer.png?v=1770300034',
},
'قشرة من الفحم': { // Charcoal Veneer Arabic
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Charcoal_Veneer.png?v=1770300034',
},

'Solid Charcoal': {
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Solid_Charcoal.png?v=1770300035',
},
'خشب صلب اسود': { // Solid Charcoal Arabic
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Solid_Charcoal.png?v=1770300035',
},

'solid oak': {
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Solid_Oak.png?v=1770300035',
},
'خشب البلوط': { // Solid Oak Arabic
  color: '#DB5D0F',
  image: 'https://cdn.shopify.com/s/files/1/0923/4481/1889/files/Solid_Oak.png?v=1770300035',
}


  };

  function applySwatches() {
    document
      .querySelectorAll('.tt-options-swatch li')
      .forEach(function (li) {
        const swatch = li.querySelector('a[data-value]');
        if (!swatch) return;

        const value =
          swatch.getAttribute('data-value') ||
          swatch.getAttribute('data-tooltip') ||
          swatch.textContent.trim();

        const key = value.trim().toLowerCase();
        const data = COLOR_SWATCH_MAP[key];

        // Only apply wrapper structure if color/image exists
        if (!data) return;

        // Create wrapper if not exists
        let wrapper = li.querySelector('.swatch-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'swatch-wrapper';
          wrapper.style.display = 'inline-block';
          wrapper.style.textAlign = 'center';
          wrapper.style.marginRight = '10px';

          li.insertBefore(wrapper, swatch);
          wrapper.appendChild(swatch);
        }

        // Create label
        let label = wrapper.querySelector('.swatch-label');
        if (!label) {
          label = document.createElement('div');
          label.className = 'swatch-label';
          label.style.marginTop = '4px';
          label.style.fontSize = '12px';
          label.style.color = '#333';
          label.textContent = value;
          wrapper.appendChild(label);
        }

        // Clean <a> text
        swatch.textContent = '';

        // Swatch styling
        swatch.classList.add('options-color');
        swatch.style.setProperty('display', 'block', 'important');
        swatch.style.setProperty('width', '30px', 'important');
        swatch.style.setProperty('height', '30px', 'important');
        swatch.style.setProperty('border-radius', '50%', 'important');
        swatch.style.setProperty('border', '1px solid rgb(204,204,204)', 'important');

        if (data.image) {
          swatch.style.setProperty(
            'background-image',
            `url(${data.image})`,
            'important'
          );
          swatch.style.setProperty('background-size', 'cover', 'important');
          swatch.style.setProperty('background-position', 'center', 'important');
          swatch.style.setProperty('background-repeat', 'no-repeat', 'important');
          swatch.style.setProperty('background-color', 'transparent', 'important');
        } else {
          swatch.style.setProperty('background-image', 'none', 'important');
          swatch.style.setProperty('background-color', data.color, 'important');
        }
      });
  }

  applySwatches();

  const observer = new MutationObserver(applySwatches);
  observer.observe(document.body, { childList: true, subtree: true });
})();










document.addEventListener("DOMContentLoaded", function () {
  const tags = document.querySelectorAll('.bestseller-tag');

  tags.forEach(function (tag) {
    const rawText = tag.textContent.trim();

    // empty
    if (rawText === '') {
      tag.style.opacity = '0';
      return;
    }

    tag.style.opacity = '1';

    // normalize text (Best seller → bestseller)
    const normalizedText = rawText.toLowerCase().replace(/\s+/g, '');

    // sirf bestseller par class add NA ho
    if (normalizedText !== 'bestseller') {
      tag.classList.add('custom-badge');
    }
  });
});







document.addEventListener('DOMContentLoaded', function () {

  const knownColors = {
    'walnut veneer': '#DB5D0F',
    'charcoal veneer': '#B58648',
    'oak veneer': '#B58648',

    'solid walnut': '#633E2F',
    'solid oak': '#A87D51',
    'solid charcoal': '#000000',

    'black': '#000000',
    'white': '#FFFFFF',

    'stone grey': '#CBC6BB',
    'gray': '#808080',

    'gold': '#D49A06',
    'beige': '#EAD8AB',
    'brown': '#9A5630',
    'bronze': '#CD7F32'
  };

  function applySwatches() {
    const swatches = document.querySelectorAll('.tt-options-swatch li');

    if (!swatches.length) return;

    swatches.forEach(function (li) {
      const a = li.querySelector('a');
      const tag = li.dataset.tag?.trim().toLowerCase();
      const colorName = a?.dataset.color?.trim().toLowerCase();
      const imgUrl = a?.dataset.image?.trim();

      if (!a || !tag) return;

      a.classList.add('options-color');

      if (!a.hasAttribute('data-tooltip')) {
        a.setAttribute(
          'data-tooltip',
          tag.charAt(0).toUpperCase() + tag.slice(1)
        );
      }

      const fallbackColor =
        knownColors[colorName] ||
        knownColors[tag] ||
        '#cccccc';

      a.style.backgroundImage = 'none';
      a.style.backgroundColor = fallbackColor;

      if (imgUrl) {
        a.style.setProperty('background-image', `url('${imgUrl}')`, 'important');
        a.style.setProperty('background-size', 'cover', 'important');
        a.style.setProperty('background-position', 'center', 'important');
        a.style.setProperty('background-color', 'transparent', 'important');
      }
    });
  }

  // Run once
  applySwatches();

  // Observe dynamic content (Shopify AJAX fix)
  const observer = new MutationObserver(function () {
    applySwatches();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



// On initial page load


// $(document).ready(function () {
//   // Run only if URL contains '/products/'
//   if (window.location.pathname.includes('/products/')) {
//     function renderSwatchLabels() {
//       $('.tt-options-swatch li a').each(function () {
//         const $this = $(this);
//         const tooltipText = $this.attr('data-tooltip');

//         // Avoid duplicate labels
//         if (tooltipText && !$this.next('.swatch-label').length) {
//           $this.removeAttr('data-tooltip');

//           const $wrapper = $('<div class="swatch-wrapper" style="display: inline-block; text-align: center; margin-right: 10px;"></div>');
//           $this.wrap($wrapper);
//           $this.after(`<div class="swatch-label" style="margin-top: 4px; font-size: 12px; color: #333;">${tooltipText}</div>`);
//         }
//       });
//     }

//     // Initial render
//     renderSwatchLabels();

//     // Observe for dynamic changes (e.g. AJAX variant changes)
//     const observer = new MutationObserver(() => {
//       renderSwatchLabels();
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
// });


 $(document).ready(function () {

  if (window.location.pathname.includes('/products/')) {

    $('.tt-product-single-info .options-color').each(function () {
      const $this = $(this);
      const tooltipText = $this.attr('data-tooltip');

      // 🔥 Remove # permanently
      $this.attr('href', 'javascript:void(0);');

      if (!$this.parent().hasClass('swatch-wrapper')) {
        $this.wrap('<div class="swatch-wrapper" style="display:inline-block; text-align:center; margin-right:10px; cursor:pointer;"></div>');
      }

      if (tooltipText && !$this.next('.swatch-label').length) {
        $this.removeAttr('data-tooltip');
        $this.after(
          `<div class="swatch-label" style="margin-top:4px; font-size:12px; color:#333; cursor:pointer;">${tooltipText}</div>`
        );
      }
    });

    // 🔥 Make full wrapper clickable
    $(document).on('click', '.tt-product-single-info .swatch-wrapper', function (e) {

      if ($(e.target).closest('.options-color').length) {
        return; // already clicking anchor
      }

      const $colorOption = $(this).find('.options-color');

      if ($colorOption.length) {
        $colorOption[0].click(); // Native click (theme JS fire karega)
      }

    });

  }

});


// $(document).ready(function () {
//   if (window.location.pathname.includes('/products/')) {

//     $('.tt-product-single-info .options-color').each(function () {
//       const $this = $(this);
//       const tooltipText = $this.attr('data-tooltip');

//       if (!$this.parent().hasClass('swatch-wrapper')) {
//         $this.wrap('<div class="swatch-wrapper" style="display:inline-block; text-align:center; margin-right:10px;"></div>');
//       }

//       if (tooltipText && !$this.next('.swatch-label').length) {
//         $this.removeAttr('data-tooltip');
//         $this.after(
//           `<div class="swatch-label" style="margin-top:4px; font-size:12px; color:#333;">${tooltipText}</div>`
//         );
//       }
//     });

//     // Click handler
//     $(document).on('click', '.tt-product-single-info .swatch-wrapper', function (e) {
//       e.preventDefault();
//       $(this).find('.options-color').trigger('click');
//     });

//   }
// });





document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('.cart-drawer .tt-dropdown-menu');
  const closeBtn = document.querySelector('.cart-drawer .tt-close');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.style.display = 'block';
      cartDrawer.classList.add('active');
      updateCartDrawer();
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      cartDrawer.style.display = 'none';
    }
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  function updateCartDrawer() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartList = cartDrawer.querySelector('.tt-cart-list');
        const cartTotal = cartDrawer.querySelector('.tt-cart-total-price');
        const cartBox = cartDrawer.querySelector('.tt-cart-box');
        const cartEmpty = cartDrawer.querySelector('.tt-cart-empty');

        if (cart.items.length === 0) {
          if (cartEmpty) cartEmpty.style.display = 'block';
          if (cartBox) cartBox.style.display = 'none';
        } else {
          if (cartEmpty) cartEmpty.style.display = 'none';
          if (cartBox) cartBox.style.display = 'block';
          if (cartList) cartList.innerHTML = '';

          cart.items.forEach(item => {
            cartList.innerHTML += `
              <div class="tt-cart-item">
                <div>${item.product_title}</div>
                <div>Qty: ${item.quantity}</div>
                <div>${(item.line_price / 100).toFixed(2)} ${cart.currency}</div>
              </div>
            `;
          });

          if (cartTotal) {
            cartTotal.innerText = (cart.total_price / 100).toFixed(2) + ' ' + cart.currency;
          }
        }
      });
  }

  


  $(document).ready(function () {
     $('#modal_quick_view .btn-addtocart').on('click', function () {
       $('#ModalquickView').modal('hide');
    });
  });
let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

});

 let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const header = document.querySelector('.tt-desktop-header');

  window.addEventListener('scroll', function () {
    let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop === 0) {
      // User is at top, remove fixed class
      header.classList.remove('sticky-visible');
    } else if (currentScrollTop < lastScrollTop) {
      // Scrolling up
      header.classList.add('sticky-visible');
    } else {
      // Scrolling down
      header.classList.remove('sticky-visible');
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  });

  document.addEventListener("DOMContentLoaded", function () {
    const pathname = window.location.pathname;
    if (pathname.includes("/account") && pathname.includes("orders")) {
      window.location.href = "/collections/desk-shelf-collection";
    }
  });




document.addEventListener("DOMContentLoaded", function () {
  const htmlLang = document.documentElement.lang.toLowerCase(); // get lang="ar" or "en"

  // Remove both classes first
  document.body.classList.remove("arebic", "english-lan");

  // Add based on actual <html lang="">
  if (htmlLang === "ar") {
    document.body.classList.add("arebic");
  } else if (htmlLang === "en") {
    document.body.classList.add("english-lan");
  }
});






 



(function ($) {

  let isProcessingVariant = false;

  /* ===============================
     MAIN PRODUCT VARIANT HANDLER
  =============================== */
  $(document).on('click', '.color-swatch', function (e) {

    // ⛔ Stop recursion
    if (isProcessingVariant) return;

    const $swatch = $(this);

    // 🔒 Ignore related products
    if ($swatch.closest('.related-products-carousel').length) {
      handleRelatedProductSwatch($swatch);
      return;
    }

    isProcessingVariant = true;

    try {
      handleMainProductSwatch($swatch);
    } finally {
      setTimeout(() => {
        isProcessingVariant = false;
      }, 0);
    }
  });

  /* ===============================
     MAIN PRODUCT LOGIC
  =============================== */
  function handleMainProductSwatch($swatch) {

    const value = $swatch.data('value');
    const $form = $swatch.closest('form');
    const $select = $form.find('select[name="id"]');

    if (!$select.length) return;

    // Update select without infinite loop
    if ($select.val() !== value) {
      $select.val(value);
      $select.trigger('change');
    }

    // Active class
    $swatch
      .addClass('active')
      .siblings('.color-swatch')
      .removeClass('active');
  }

  /* ===============================
     RELATED PRODUCT LOGIC (UI ONLY)
  =============================== */
  function handleRelatedProductSwatch($swatch) {

    const $card = $swatch.closest('.tt-product');

    // Active UI
    $swatch
      .addClass('active')
      .siblings('.color-swatch')
      .removeClass('active');

    // Change image safely
    const img = $swatch.data('image');
    if (img && $card.find('img').length) {
      $card.find('img').first().attr('src', img);
    }
  }

})(jQuery);

/* =====================================================
   PRODUCT ADD TO CART - AJAX
   ===================================================== */

$(document).off('submit.customAddToCart', '.shopify-product-form');

$(document).on('submit.customAddToCart', '.shopify-product-form', function (e) {

  e.preventDefault();
  e.stopImmediatePropagation();

  var $form = $(this);
  var $button = $form.find('.btn-addtocart');

  if ($button.hasClass('custom-loading')) {
    return false;
  }

  var variantId = $form.find('.input_variant[name="id"]').val();

  if (!variantId) {
    console.error('ADD TO CART: Variant ID missing');
    return false;
  }

  $button.addClass('custom-loading');

  console.log('ADDING VARIANT:', variantId);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $form.serialize(),
    dataType: 'json',

    success: function (item) {

      console.log('PRODUCT ADDED:', item);

      if (
        typeof Shopify !== 'undefined' &&
        typeof Shopify.onItemAdded === 'function'
      ) {
        Shopify.onItemAdded(item);
      }

    },

    error: function (xhr) {

      console.error(
        'ADD TO CART ERROR:',
        xhr.responseJSON || xhr.responseText
      );

    },

    complete: function () {
      $button.removeClass('custom-loading');
    }

  });

  return false;
});